'use strict';

module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.options = Chart.helpers.configMerge({aspectRatio: 1}, config.options);
		config.type = 'radar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/chart.js/src/charts/Chart.Radar.js
// module id = 507
// module chunks = 0